import { IRecentSearch } from '@/interfaces/deltaGpt/IRecentSearch.ts';
import type { ColourPaletteId } from '@/constants/ColourPalettes.ts';

export enum ResearchSelectionType {
    AllProducts = 'AllProducts',
    MyProducts = 'MyProducts',
    PublicProducts = 'PublicProducts',
}

export interface IFeedVisitState {
    yourFeedLastVisitedAt?: string | null;
    allFeedLastVisitedAt?: string | null;
    sectionFeedLastVisitedAtByRouteName: Record<string, string>;
    attentionDismissedAt?: string | null;
}

export interface IDeltaUserSettings {
    isDarkMode: boolean;
    colourPaletteId?: ColourPaletteId | null;
    /** @deprecated Use researchSelection instead. */
    showMyProducts?: boolean | null;
    researchSelection?: ResearchSelectionType | null;
    researchSearchSelection?: ResearchSelectionType | null;
    recentSearches: Array<IRecentSearch>;
    pinnedSearches: Array<IRecentSearch>;
    pinnedSearchCategories: Array<string>;
    likedResearchIds: Array<string>;
    interestAreas: Array<string>;
}

export interface IUserTrackingData {
    viewedDocumentShortCodes: Array<string>;
    feedVisitState: IFeedVisitState;
}
